/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 10:53:27
 * @LastEditTime: 2020-09-27 09:37:30
 * @Description: 公司store
 */
import {
    getCompanyList,
    updateCompany,
    deleteCompany,
    createCompany,
    getCompanyByID
} from '@/api/company'
import Vue from 'vue'

const state = {
    companyList: [],
    totalCounts: 0,
}

const actions = {
    async getCompanyListAction({
        commit
    }, payload) {
        try {
            const companyList = await getCompanyList(payload);
            commit('SETCOMPANYLIST', companyList.data)
        } catch (error) {
            throw error.message
        }
    },
    async getCompanyByIDAction({
        commit
    }, payload) {
        try {
            const company = await getCompanyByID(payload)
            return company.data
        } catch (error) {
            throw error.message
        }
    },
    async createCompanyAction({
        commit
    }, payload) {
        try {
            const newCompany = await createCompany(payload);
            commit('ADDNEWCOMPANY', newCompany.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateCompanyAction({
        commit
    }, payload) {
        try {
            const newcCompany = await updateCompany(payload.id, payload.data)
            commit('UPDATECOMPANY', newcCompany.data)
        } catch (error) {
            throw error.message
        }
    },
    async deleteCompanyAction({
        commit
    }, payload) {
        try {
            await deleteCompany(payload)
        } catch (error) {
            throw error.message
        }
    }
}

const mutations = {
    SETCOMPANYLIST(state, payload) {
        state.companyList = payload.companyList;
        state.totalCounts = payload.totalCounts
    },
    ADDNEWCOMPANY(state, company) {
        state.companyList.unshift(company)
        state.totalCounts++
    },
    UPDATECOMPANY(state, company) {
        Vue.set(state.companyList, state.companyList.findIndex(x => x._id === company._id), company)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}